<template>
  <v-avatar size="32" class="mr-3">
    <img :src="jerarquiaPath()" />
  </v-avatar>
</template>

<script>
import j1 from "@/assets/img/jerarquias/1.png";
import j2 from "@/assets/img/jerarquias/2.png";
import j3 from "@/assets/img/jerarquias/3.png";
import j4 from "@/assets/img/jerarquias/4.png";
import j5 from "@/assets/img/jerarquias/5.png";
import j6 from "@/assets/img/jerarquias/6.png";
import j7 from "@/assets/img/jerarquias/7.png";
import j8 from "@/assets/img/jerarquias/8.png";
import j9 from "@/assets/img/jerarquias/9.png";
import j10 from "@/assets/img/jerarquias/10.png";
import j11 from "@/assets/img/jerarquias/11.png";
import j12 from "@/assets/img/jerarquias/12.png";
import j13 from "@/assets/img/jerarquias/13.png";
import j14 from "@/assets/img/jerarquias/14.png";
import j15 from "@/assets/img/jerarquias/15.png";
import j16 from "@/assets/img/jerarquias/16.png";
import j17 from "@/assets/img/jerarquias/17.png";
import j18 from "@/assets/img/jerarquias/18.png";
import j19 from "@/assets/img/jerarquias/19.png";
import j20 from "@/assets/img/logo.png";
export default {
  props: {
    id: 0,
  },
  methods: {
    jerarquiaPath() {
      const jerarquias = [
        j1,
        j2,
        j3,
        j4,
        j5,
        j6,
        j7,
        j8,
        j9,
        j10,
        j11,
        j12,
        j13,
        j14,
        j15,
        j16,
        j17,
        j18,
        j19,
        j20,
      ];
      return jerarquias[this.id - 1];
    },
  },
};
</script>

<style>
</style>